import { render, staticRenderFns } from "./StudentPlacementtestHistory.vue?vue&type=template&id=233227c8&"
import script from "./StudentPlacementtestHistory.vue?vue&type=script&lang=js&"
export * from "./StudentPlacementtestHistory.vue?vue&type=script&lang=js&"
import style0 from "./StudentPlacementtestHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports